<template>
  <div class="custom-popover" ref="popover">
    <!-- <div v-if="backdrop" class="backdrop" @click.self.prevent.stop="$emit('backdrop-clicked')"></div> -->
    <div v-if="backdrop" class="backdrop" @click.self.prevent.stop="$emit('close')"></div>
    <div v-if="!closeButtonOff" @click="onClose" class="close-button">
      <img src="@/assets/svg/close.svg" />
    </div>
    <div style="position: relative; z-index: 100;  border-radius: 10px;" >
      <slot />
    </div>
  </div>
</template>

<script>
import EventBus from "@/assets/js/eventBus.js";
export default {
  name: "popover",
  props: {
    backdrop: Boolean,
    backdropClose: Boolean,
    closeButtonOff: Boolean
  },
  methods: {
    onClose() {
      EventBus.$emit("popover-close");
      this.$emit('close')
    }
  },
  created(){
    EventBus.$emit("popover-opened");
  },
  mounted() {}
};
</script>

<style lang="less">
.backdrop {
  position: fixed;
  z-index: 99;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.25);
}

.custom-popover {
  border-radius: var(--standard-border-radius);
  color: #fff;
  background-color: #fff;
  position: absolute;
  display: block;
  top:  0;
  left: 0;
  z-index: 100;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.25);

  &:before {
    content: "";
    border-left: 7px solid transparent;
    border-right: 7px solid transparent;
    border-bottom: 7px solid #fff;
    position: absolute;
    display: block;
    z-index: 100;
    top: -7px;
    left: 5px;
  }

  .close-button {
    display: none;
    position: absolute;
    top: -13px;
    right: -12px;
    z-index: 101;

    &:hover {
      cursor: pointer;
    }

    img {
      width: 24px;
    }
  }
  
	.popover-header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background-color: var(--background-white);
		box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.2);
		position: relative;
		z-index: 100;
		color: #8F979C;
		letter-spacing: .6px;
		padding: 14px 20px 12px 20px;
    border-radius: 10px 10px 0 0;

    &.subtle{
      box-shadow: unset;
      border: none;
      h2{
        font-size: 18px;
        color: var(--charcoal);
        margin: 0;
      }
      .left-side-header{
        display: flex;
        gap: 12px;
        .close-popover{
          cursor: pointer;
          display: flex;
          align-items: center;
          svg{
            font-size: 12px;
            color: var(--charcoal);
          }

          &:hover{
            svg{
              filter: brightness(200%);
            }
          }
        }
      }
    }
	}

  .popover-step {
    width: 300px;
    background-color: #fff;
    &:first-child {
      border-radius: 0 0 0 10px;
    }
    &:last-child {
      border-radius: 0 0px 10px 0;
    }
  }
}
</style>


